import { IconProps } from './icons-props';

function BotIcon({ className, width = 20, height = 20 }: IconProps) {
    return (
        <svg
            className={className}
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M9.16667 15V17.5C9.16667 17.9583 8.79167 18.3333 8.33333 18.3333C7.875 18.3333 7.5 17.9583 7.5 17.5V15H9.16667Z'
                fill='currentColor'
            />
            <path
                d='M12.5002 15V17.5C12.5002 17.9583 12.1252 18.3333 11.6668 18.3333C11.2085 18.3333 10.8335 17.9583 10.8335 17.5V15H12.5002Z'
                fill='currentColor'
            />
            <path
                d='M14.1668 9.16667V13.3333C14.1668 14.25 13.4168 15 12.5002 15H7.50016C6.5835 15 5.8335 14.25 5.8335 13.3333V9.16667C5.8335 8.25 6.5835 7.5 7.50016 7.5H12.5002C13.4168 7.5 14.1668 8.25 14.1668 9.16667Z'
                fill='currentColor'
            />
            <path
                d='M4.16667 9.16683V12.5002C4.16667 12.9585 3.79167 13.3335 3.33333 13.3335C2.875 13.3335 2.5 12.9585 2.5 12.5002V9.16683C2.5 8.7085 2.875 8.3335 3.33333 8.3335C3.79167 8.3335 4.16667 8.7085 4.16667 9.16683Z'
                fill='currentColor'
            />
            <path
                d='M17.5002 9.16683V12.5002C17.5002 12.9585 17.1252 13.3335 16.6668 13.3335C16.2085 13.3335 15.8335 12.9585 15.8335 12.5002V9.16683C15.8335 8.7085 16.2085 8.3335 16.6668 8.3335C17.1252 8.3335 17.5002 8.7085 17.5002 9.16683Z'
                fill='currentColor'
            />
            <path
                d='M7.99982 6.33318H11.9999C12.7332 6.33318 13.3332 5.73317 13.3332 4.99984C13.3332 3.15817 11.8415 1.6665 9.99984 1.6665C8.15817 1.6665 6.6665 3.15817 6.6665 4.99984C6.6665 5.73317 7.26648 6.33318 7.99982 6.33318Z'
                fill='currentColor'
            />
        </svg>
    );
}

export default BotIcon;

